import React from "react";
import { Badge, Card, Table, Row, Col } from "react-bootstrap";
import { formatNumberWithCommas, roundToTwoDecimalDigits } from "../../../../../utils/utility";

const CreditNoteApprovalView = ({ creditNotes }) => {
    return (
        <>
            <Card>
                <Card.Body>
                    <Table responsive bordered size="sm">
                        <tbody>
                            {creditNotes?.invoice_course_students?.students
                                ?.length > 0 && (
                                <tr>
                                    <td width="50%">Student</td>
                                    <td>
                                        {creditNotes?.invoice_course_students?.students?.map(
                                            (name, index) => {
                                                return (
                                                    <div key={index}>
                                                        {index + 1}. {name}
                                                    </div>
                                                );
                                            }
                                        )}
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td>Type</td>
                                <td>
                                    <Badge style={{ textTransform: 'capitalize' }}>{creditNotes?.type}</Badge>
                                </td>
                            </tr>
                            <tr>
                                <td>Reason</td>
                                <td>{creditNotes?.reason}</td>
                            </tr>
                            <tr>
                                <td>Remarks</td>
                                <td>{creditNotes?.remarks}</td>
                            </tr>
                            <tr>
                                <td>Refund</td>
                                <td style={{ textTransform: 'capitalize' }}>
                                    <Badge> {creditNotes?.refund}</Badge>
                                </td>
                            </tr>
                            {/* {creditNotes?.refund?.toUpperCase() === "YES" && (
                                <>
                                    <tr>
                                        <td> Amountss</td>
                                        <td>${creditNotes?.amount}</td>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>Deduction fee</th>
                                    </tr>
                                    <tr>
                                        <td> Admin fee</td>
                                        <td>
                                            {creditNotes?.deduction?.admin_fee
                                                ? `$${creditNotes?.deduction?.admin_fee} `
                                                : "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td> Test fee</td>
                                        <td>
                                            {creditNotes?.deduction?.test_fee
                                                ? `$${creditNotes?.deduction?.test_fee} `
                                                : "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td> BCA fee</td>
                                        <td>
                                            {creditNotes?.deduction?.bca_fee
                                                ? `$${creditNotes?.deduction?.bca_fee} `
                                                : "-"}
                                        </td>
                                    </tr>
                                </>
                            )} */}
                            <tr>
                                <td> Amount</td>
                                <td>${roundToTwoDecimalDigits(parseFloat(creditNotes?.has_or_none_gst_amount))}</td>
                            </tr>
                            <tr>
                                <th colSpan={2}>Deduction fee</th>
                            </tr>
                            <tr>
                                <td> Admin fee</td>
                                <td>
                                    {creditNotes?.deduction?.admin_fee
                                        ? `$${creditNotes?.deduction?.admin_fee} `
                                        : "-"}
                                </td>
                            </tr>
                            <tr>
                                <td> Test fee</td>
                                <td>
                                    {creditNotes?.deduction?.test_fee
                                        ? `$${creditNotes?.deduction?.test_fee} `
                                        : "-"}
                                </td>
                            </tr>
                            <tr>
                                <td> BCA fee</td>
                                <td>
                                    {creditNotes?.deduction?.bca_fee
                                        ? `$${creditNotes?.deduction?.bca_fee} `
                                        : "-"}
                                </td>
                            </tr>
                            <tr>
                                <td>Supporting documents</td>
                                <td>
                                    {creditNotes?.attachments?.length === 0 &&
                                        "-"}

                                    {creditNotes?.attachments?.map(
                                        (attachment, index) => {
                                            return (
                                                <div key={index}>
                                                    {index + 1} .{" "}
                                                    <a
                                                        href={
                                                            attachment?.full_path
                                                        }
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {attachment?.file_name}
                                                    </a>
                                                </div>
                                            );
                                        }
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={2}>Summary</th>
                            </tr>
                            <tr>
                                <td>Invoice Subtotal</td>
                                <td>${roundToTwoDecimalDigits(parseFloat(creditNotes?.deduction_calculations?.subtotal))}</td>
                            </tr>
                            <tr>
                                <td>Total Tax before Tax</td>
                                <td>${roundToTwoDecimalDigits(parseFloat(creditNotes?.deduction_calculations?.subtotal))}</td>
                            </tr>
                            <tr>
                                <td>Total tax amount GST {(parseFloat(creditNotes?.invoice?.gst) / 100) * 100}%</td>
                                <td>${roundToTwoDecimalDigits(parseFloat(creditNotes?.deduction_calculations?.gst_amount))}</td>
                            </tr>
                            <tr>
                                <td>Total amount</td>
                                <td>${roundToTwoDecimalDigits(parseFloat(creditNotes?.deduction_calculations?.total_amount))}</td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th colSpan={2}>
                                                    Sales director status :
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Status :</td>
                                                <td>
                                                    {creditNotes?.sales_director_status
                                                        ? creditNotes?.sales_director_status.charAt(0).toUpperCase() + creditNotes?.sales_director_status.slice(1).toLowerCase()
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Date :</td>
                                                <td>
                                                    {creditNotes?.sales_director
                                                        ?.date
                                                        ? new Date(creditNotes?.sales_director?.date).toLocaleString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: '2-digit'}).replace(/\//g, '-').replace(',', ', ')
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Remarks :</td>
                                                <td>
                                                    {creditNotes?.sales_director
                                                        ?.remarks
                                                        ? creditNotes
                                                              ?.sales_director
                                                              ?.remarks
                                                        : "-"}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th colSpan={2}>
                                                    Finance director status :
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Status :</td>
                                                <td>
                                                    {creditNotes?.finance_director_status
                                                        ? creditNotes?.finance_director_status.charAt(0).toUpperCase() + creditNotes?.finance_director_status.slice(1).toLowerCase()
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Date :</td>
                                                <td>
                                                    {creditNotes
                                                        ?.finance_director?.date
                                                        ? new Date(creditNotes?.finance_director?.date).toLocaleString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'}).replace(/\//g, '-').replace(',', ', ')
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Remarks :</td>
                                                <td>
                                                    {creditNotes
                                                        ?.finance_director
                                                        ?.remarks
                                                        ? creditNotes
                                                              ?.finance_director
                                                              ?.remarks
                                                        : "-"}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            {creditNotes?.refund?.toUpperCase() !== "YES" && (
                                <>
                                    <tr>
                                        <th colSpan={2}>Status</th>
                                    </tr>
                                    
                                    <tr>
                                        <td>Status</td>
                                        <td>
                                            <Badge
                                                bg={
                                                    creditNotes?.status_key?.toUpperCase() ===
                                                    "PENDING"
                                                        ? "danger"
                                                        : "success"
                                                }
                                            >
                                                {creditNotes?.status}
                                            </Badge>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Status updated on</td>
                                        <td>
                                            { creditNotes?.status_date 
                                                ? new Date(creditNotes?.status_date).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/\//g, '-')
                                                : '-'
                                            }
                                        </td>
                                                    
                                    </tr>
                                </>
                            )}
                            
                            {creditNotes?.refund?.toUpperCase() === "YES" && (
                                <>
                                    <tr>
                                        <th colSpan={2}>Refund status</th>
                                    </tr>
                                    <tr>
                                        <td> Status</td>
                                        <td><Badge
                                        bg={
                                            creditNotes?.status_key?.toUpperCase() ===
                                            "PENDING"
                                                ? "danger"
                                                : "success"
                                        }
                                    >
                                        {creditNotes?.status}
                                    </Badge></td>
                                    </tr>
                                    <tr>
                                        <td> Amount</td>
                                        <td>${creditNotes?.amount}</td>
                                        {/* <td>{creditNotes?.refund_amount ?? "-"}</td> */}
                                    </tr>
                                    <tr>
                                        <td> Date</td>
                                        <td>
                                            { creditNotes?.refund_date
                                                ? new Date(creditNotes?.status_date).toLocaleString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'}).replace(/\//g, '-').replace(',', ', ')
                                                : '-'
                                            }
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
};

export default CreditNoteApprovalView;
